import PropTypes from 'prop-types';
import React from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';

export default class DeleteConfirmation extends React.Component {
  static propTypes = {
    content: PropTypes.string,
    delete: PropTypes.func,
    trigger: PropTypes.node,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      deleting: false,
      mounted: false
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.delete = this.delete.bind(this);
  }

  componentDidMount() {
    this.mounted();
  }

  mounted() {
    this.setState({ mounted: true });
  }

  closeModal(e) {
    this.setState({ modalOpen: false });
    if (this.props.onClose) this.props.onClose(e);
  }

  openModal() {
    this.setState({ modalOpen: true });
  }

  delete(e) {
    this.setState({ deleting: true, modalOpen: false });
    if (this.props.onClose) this.props.onClose(e);
    this.props.delete(e);
  }

  render() {
    return (
      <div ref='mountNode' className='ignore-react-onclickoutside'>
        {this.state.mounted &&
          <Modal
            trigger={
              this.props.trigger
                ? React.cloneElement(this.props.trigger, {
                  onClick: this.openModal
                })
                : undefined
            }
            open={this.props.open || this.state.modalOpen}
            onClose={this.props.onClose}
            mountNode={this.refs.mountNode}
            size='small'
          >
            <Header
              content={
                this.props.title ? this.props.title : 'Delete confirmation'
              }
            />
            <Modal.Content>
              <h3>
                {this.props.content
                  ? this.props.content
                  : 'Are you sure you want to delete this item?'}
              </h3>
            </Modal.Content>
            <Modal.Actions>
              <Button basic onClick={this.closeModal}>
                Cancel
              </Button>
              <Button
                color='red'
                onClick={this.delete}
                disabled={this.state.deleting}
              >
                <Icon name='delete' /> Delete
              </Button>
            </Modal.Actions>
          </Modal>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/Dialogs/DeleteConfirmation.js